var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDesignLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19654)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0222 23.323C29.4518 22.8934 30.1482 22.8934 30.5778 23.323L37.4778 30.223C37.5065 30.2517 37.5336 30.2819 37.559 30.3136C38.2803 31.2154 38.2803 32.4862 37.559 33.388C37.5336 33.4197 37.5065 33.4499 37.4778 33.4786L33.4778 37.4786C33.0415 37.9149 32.4688 38.1758 31.85 38.1758C31.2312 38.1758 30.6585 37.9149 30.2222 37.4786L23.3222 30.5786C22.8926 30.149 22.8926 29.4526 23.3222 29.023L29.0222 23.323ZM29.8 25.6564L25.6556 29.8008L31.7778 35.923C31.8117 35.9568 31.8357 35.9693 31.8448 35.9733C31.847 35.9742 31.8488 35.9749 31.85 35.9753C31.8512 35.9749 31.853 35.9742 31.8552 35.9733C31.8643 35.9693 31.8883 35.9568 31.9222 35.923L35.8629 31.9823C35.9124 31.8998 35.9124 31.8018 35.8629 31.7193L29.8 25.6564Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8129 10.6414C15.7147 9.92005 16.9855 9.92005 17.8873 10.6414C17.921 10.6685 17.9532 10.6975 17.9836 10.7283L24.7836 17.6283C25.2078 18.0588 25.2053 18.7509 24.7779 19.1782L19.1779 24.7782C18.7506 25.2056 18.0584 25.2081 17.628 24.7839L10.728 17.9839C10.6972 17.9535 10.6682 17.9214 10.6411 17.8876C9.91975 16.9858 9.91975 15.715 10.6411 14.8132C10.6665 14.7815 10.6936 14.7513 10.7223 14.7226L14.7223 10.7226C14.751 10.6939 14.7812 10.6668 14.8129 10.6414ZM16.2186 12.3375L12.3372 16.2189C12.2882 16.3007 12.2877 16.3977 12.3359 16.4797L18.3944 22.4504L22.4501 18.3947L16.4794 12.3362C16.3974 12.288 16.3004 12.2885 16.2186 12.3375Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3776 28.7791L31.5776 31.5791L30.022 30.0234L32.822 27.2234L34.3776 28.7791Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9777 15.3787L18.1777 18.1787L16.6221 16.6231L19.4221 13.8231L20.9777 15.3787Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4249 14.4199C26.8549 13.9929 27.5493 13.9941 27.9778 14.4226L33.7778 20.2226C33.9846 20.4293 34.1005 20.7099 34.1 21.0023C34.0995 21.2947 33.9826 21.5748 33.7751 21.7809L19.1751 36.2809C19.0367 36.4183 18.8643 36.5165 18.6754 36.5654L12.8754 38.0654C12.8632 38.0685 12.8509 38.0715 12.8386 38.0742C11.1527 38.4489 9.65154 36.9477 10.0262 35.2618C10.0289 35.2495 10.0319 35.2372 10.035 35.225L11.535 29.425C11.5845 29.2337 11.6846 29.0592 11.8249 28.9199L26.4249 14.4199ZM13.5894 30.2681L12.1719 35.749C12.1548 35.8554 12.2449 35.9456 12.3514 35.9285L17.8362 34.51L31.4417 20.9977L27.1973 16.7534L13.5894 30.2681Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4222 11.3222C31.2517 9.49262 34.2482 9.49262 36.0778 11.3222L36.7652 12.0096C38.7317 13.8601 38.6872 16.8684 36.7778 18.7778L33.7778 21.7778C33.5704 21.9853 33.2886 22.1013 32.9953 22.1C32.7019 22.0987 32.4212 21.9804 32.2155 21.7712L26.4155 15.8712C25.9922 15.4405 25.9952 14.7492 26.4222 14.3222L29.4222 11.3222ZM34.5222 12.8778C33.5517 11.9074 31.9482 11.9074 30.9778 12.8778L28.749 15.1066L33.0067 19.4377L35.2222 17.2222C36.308 16.1363 36.2681 14.5549 35.2494 13.6042C35.2402 13.5955 35.2311 13.5868 35.2222 13.5778L34.5222 12.8778Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 28.2,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesignLight);
export default __webpack_public_path__ + "static/media/icon_design_light.b21a63a1.svg";
export { ForwardRef as ReactComponent };